import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { PROCESS_TYPE } from 'features/sendouts/constants/constants';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const ENDPOINT_BY_PROCESS_TYPE = {
  [PROCESS_TYPE.Sendout.id]: Endpoints.JobOrderSendouts,
  [PROCESS_TYPE.Sendover.id]: Endpoints.JobOrderSendovers
};

const buildCreateAlert = ({ processType, severity, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: processType.title,
    action:
      severity === 'success' ? SUBMIT_MESSAGES.actions.created : SUBMIT_MESSAGES.actions.creating
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const createProcess = async ({ processType, jobOrderId, payload }) => {
  try {
    const endpoint = ENDPOINT_BY_PROCESS_TYPE[processType.id].replace(':id', jobOrderId);
    const response = await API.post(endpoint, payload, { apiVersion: 2 });

    if (response.status !== HTTPStatusCodes.Created) {
      return {
        success: false,
        response,
        alert: buildCreateAlert({
          processType,
          severity: 'error',
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildCreateAlert({ processType, severity: 'success' })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildCreateAlert({
        processType,
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
